import { useEntitlements, EntitlementsStatus } from 'context/plan'

export type TickerBarSurfaceVisibility = 'visible' | 'hidden' | 'pending'

export const resolveTickerBarSurfaceVisibility = ({ status, tickerBarAccess }: {
  status: EntitlementsStatus
  tickerBarAccess: boolean
}): TickerBarSurfaceVisibility => {
  if (status === 'loading') return 'pending'
  return status === 'ready' && tickerBarAccess ? 'visible' : 'hidden'
}

export const tickerBarPageGuard = (v: TickerBarSurfaceVisibility): 'render' | 'wait' | 'redirect' =>
  v === 'visible' ? 'render' : v === 'pending' ? 'wait' : 'redirect'

export const useTickerBarSurfaceVisible = (): TickerBarSurfaceVisibility => {
  const { status, tickerBarAccess } = useEntitlements()
  return resolveTickerBarSurfaceVisibility({ status, tickerBarAccess })
}
